$(document).ready(function() {
 
  $('.slider').each(function(key, item) {
    var sliderIdName = 'slider' + key;
    var sliderNavIdName = 'sliderNav' + key;

    this.id = sliderIdName;
    $('.product .options')[key].id = sliderNavIdName;

    var sliderId = '#' + sliderIdName;
    var sliderNavId = '#' + sliderNavIdName;

    // Initiate Slider
    $(sliderId).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      autoplay: false,
      infinite: false,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      asNavFor: sliderNavId
    });

    $(sliderNavId).slick({
      slidesToShow: 12,
      slidesToScroll: 0,
      asNavFor: sliderId,
      dots: false,
      arrows: false,
      centerMode: false,
      focusOnSelect: true
    });
  });
  
  // Add active class to first option
  $('.product .options').each(function() {
    $('.product .options li:first-child').find('a').addClass('active');
  });
  
  // Selecting an option
  $('.product .options li a').click(function() {
	var li = $(this);
    var label = $(this).data('color');
    var price = $(this).data('price');
    $(this).closest('ul').find('a').removeClass('active');
    li.addClass('active');
    $(this).closest('.product').find('.color').text(label);
    $(this).closest('li').find('input').prop('checked', true);
    $(this).closest('.product').find('.price .money').html(Shopify.formatMoney(price).replace(".00", ""));
      //$(this).closest('.product').find('.price .money').html().replace(".00", "");

    var productId = $(this).closest('.product').find('form').data('product-form');

    $('.affirm-as-low-as[data-id="affirm-'+productId+'"]').attr('data-amount',price);
    affirm.ui.refresh();

  });
  
  // Apply active class to options when clicking slider dots
  $('.product .slick-dots li').click(function() {
  	var slide = $(this).closest('.slider').find('.slick-slide.slick-active').data('slide');
    var color = $(this).closest('.product').find('.options .' + slide + ' a').data('color');
    $(this).closest('.product').find('.options a').removeClass('active');
    $(this).closest('.product').find('.options .' + slide + ' a').addClass('active');
    $(this).closest('.product').find('.color').text(color);
    $(this).closest('.product').find('.options .' + slide + ' input').prop('checked', true);
  });
  
});

// -------------------------------------------------------------------------------------
// POST to cart/add.js returns the JSON of the line item associated with the added item.
// -------------------------------------------------------------------------------------
/*
Shopify.addItem = function(variant_id, quantity, callback) {
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function(line_item) { 
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};*/